import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import UIButton from 'UIComponents/button/UIButton';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UIStatusDot from 'UIComponents/tag/UIStatusDot';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WebhookEditTableHoverCell = ({
  propertyLabel,
  onEditProperty,
  hasChanges
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    children: [/*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(UITruncateString, {
        children: propertyLabel
      }), hasChanges && /*#__PURE__*/_jsxs(Small, {
        use: "help",
        children: [/*#__PURE__*/_jsx(UIStatusDot, {
          use: "default"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.table.changesApplied",
          options: {
            count: 1
          }
        })]
      })]
    }), /*#__PURE__*/_jsx(UITableHoverContent, {
      children: /*#__PURE__*/_jsx(UIButton, {
        responsive: false,
        onClick: onEditProperty,
        size: "extra-small",
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.editPanel.webhookDefinition.table.edit"
        })
      })
    })]
  });
};
export default WebhookEditTableHoverCell;